import React, { useEffect } from 'react'

const LinkedInInsight = ({ partnerId = '8405585', includeInDevelopment = false }) => {
  useEffect(() => {
    // Only load in production unless explicitly enabled for development
    if (process.env.NODE_ENV === 'development' && !includeInDevelopment) {
      return
    }

    // Check if script is already loaded
    if (window._linkedin_data_partner_ids) {
      return
    }

    // Initialize LinkedIn Insight
    window._linkedin_partner_id = partnerId
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []
    window._linkedin_data_partner_ids.push(window._linkedin_partner_id)

    // Initialize lintrk function for event tracking (this was missing!)
    if (!window.lintrk) {
      window.lintrk = function(a, b) {
        window.lintrk.q.push([a, b])
      }
      window.lintrk.q = []
    }

    // Load the LinkedIn Insight script
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js'
    
    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode.insertBefore(script, firstScript)

    // Create noscript fallback
    const noscript = document.createElement('noscript')
    const img = document.createElement('img')
    img.height = '1'
    img.width = '1'
    img.style.display = 'none'
    img.alt = ''
    img.src = `https://px.ads.linkedin.com/collect/?pid=${partnerId}&fmt=gif`
    noscript.appendChild(img)
    document.head.appendChild(noscript)
  }, [partnerId, includeInDevelopment])

  return null
}

export default LinkedInInsight 